import React, { FC, useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Heading } from '@ucheba/ui/components/Heading/touch'
import { feedbacksSelectors } from '@ucheba/store/feedbacks'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { p11n } from '@ucheba/utils/helpers/string'
import { authSelectors } from '@ucheba/store/auth'
import { useRouter } from 'next/router'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { scrollTo } from '@ucheba/utils/helpers/components'
import { Banner } from '../../../../../../components/Banner/desktop'
import { EFormType } from '../../../../../../components/UsersCommunication/types'
import CommunicationForm from '../../../../../../components/UsersCommunication/desktop/CommunicationForm'
import LayoutInstitution from '../../../../../../components/LayoutInstitution/desktop'
import EmptyListPlaceholder from '../../../../components/EmptyListPlaceholder'
import ListFeedbacks from './ListFeedbacks'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'
import { useCommentsAndFeedbacksRequestCore } from '../../bll'

const InstitutionOpinionsPage: FC = () => {
  const feedbacks = useSelector(feedbacksSelectors.entity)
  const institution = useSelector(institutionItemSelectors.currentInstitution)
  const [openCommunicationForm, setOpenCommunicationForm] = useState(false)
  const isAuth = useSelector(authSelectors.isAuth)
  const { push, asPath, replace, query } = useRouter()

  const { offset, onAfterSubmit, limit } = useCommentsAndFeedbacksRequestCore({
    type: 'feedbacks',
  })

  const handleOpenCommunicationForm = useCallback(() => {
    if (isAuth) {
      setOpenCommunicationForm((prevValue) => !prevValue)
    } else {
      push(
        stringifyUrl(`/auth`, {
          update: {
            redirect: stringifyUrl(asPath, {
              update: {
                feedbacks: 1,
              },
            }),
          },
        }),
        undefined,
        {}
      )
    }
  }, [isAuth, asPath, push])

  const { extraParams, paidPackage } = useBannerProgramTypes()

  useEffect(() => {
    if (query.feedbacks && !feedbacks?.total) {
      setOpenCommunicationForm((prevValue) => !prevValue)

      scrollTo('feedbacks')

      replace(
        stringifyUrl(asPath, {
          update: {
            ...query,
          },
          exclude: ['feedbacks'],
        }),
        undefined,
        { shallow: true, scroll: false }
      )
    }
  }, [])

  return (
    <>
      <LayoutInstitution
        questionsListLimit={limit}
        questionsListOffset={offset}
        onQuestionAfterSubmit={onAfterSubmit}
      >
        {!feedbacks?.total ? (
          <div id='feedbacks'>
            <Heading
              as='h1'
              h2={`${feedbacks?.total} ${p11n(
                feedbacks?.total || 0,
                'отзыв',
                'отзыва',
                'отзывов'
              )}`}
              spacing='large'
            />

            <EmptyListPlaceholder
              title='Пока никто не оставлял отзывов об этом учебном заведении'
              linkText='Добавить отзыв первым'
              onClick={handleOpenCommunicationForm}
            />
          </div>
        ) : (
          <ListFeedbacks limit={limit} offset={offset} onAfterSubmit={onAfterSubmit} />
        )}
      </LayoutInstitution>

      <CommunicationForm
        parentId={null}
        onClose={handleOpenCommunicationForm}
        formType={EFormType.feedbacks}
        isOpen={openCommunicationForm}
        rootId={institution.id}
        list={feedbacks?.items || []}
        type='institution'
        limit={limit}
        offset={offset}
      />

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}

      {!isPaidPackage(paidPackage) && <Banner id={14} extraParams={extraParams} />}
    </>
  )
}

export default InstitutionOpinionsPage
